export default __webpack_public_path__ + "static/media/balance bike days.ca8bd5e6.jpeg";